module.exports = __webpack_public_path__ + "static/media/logoamexline.02c756fc.svg";